<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card v-if="selectedProduct">
        <v-card-text>
          <v-text-field
            v-model="selectedProduct.width"
            label="Plotis"
            type="number"
            min="0"
            step="10"
          ></v-text-field>
          <v-text-field
            v-model="selectedProduct.height"
            label="Aukštis"
            type="number"
            min="0"
            step="10"
          ></v-text-field>
          <v-text-field
            v-model="selectedProduct.depth"
            label="Storis"
            type="number"
            min="0"
            step="10"
          ></v-text-field>
          <v-text-field
            v-model="selectedProduct.weight"
            label="Svoris"
            type="number"
            min="0"
            step="10"
          ></v-text-field>
          <div class="action-buttons">
            <div class="confirm-button">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="green" :disabled="disabled" @click="save()" v-on="on">
                    <v-icon color="white">done</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("truck_maker.confirm") }}</span>
              </v-tooltip>
            </div>
            <div class="cancel-button">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="red" @click="dialog = false" v-on="on">
                    <v-icon color="white">close</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("truck_maker.cancel") }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Product from "@/models/Product.js";
export default {
  data() {
    return {
      dialog: false,
      selectedProduct: null,
      onKeyup: e => {
        if(e.key == "Escape"){
          this.dialog = false;
        }
        if(e.key == "Enter"){
          if(!this.disabled){
            this.save();
          }
        }
      }
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyup.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.selectedProduct = null;
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    }
  },
  computed: {
    disabled() {
      if (this.selectedProduct == null) return true;
      if (this.selectedProduct.height < 0 || this.selectedProduct.height == "")
        return true;
      if (this.selectedProduct.width < 0 || this.selectedProduct.width == "")
        return true;
      if (this.selectedProduct.depth < 0 || this.selectedProduct.depth == "")
        return true;
      if (this.selectedProduct.weight < 0 || this.selectedProduct.weight == "")
        return true;
      return false;
    }
  },
  methods: {
    async open(stack) {
      this.dialog = true;
      this.selectedProduct = await Product.loadProduct(stack.products[0].id);
    },
    async save() {
      this.$store.commit('setLoading', true);
      await this.selectedProduct.save({
        height: this.selectedProduct.height,
        width: this.selectedProduct.width,
        depth: this.selectedProduct.depth,
        weight: this.selectedProduct.weight
      });
      this.dialog = false;
      this.$emit("productUpdated");
    }
  }
};
</script>

<style scoped>
.action-buttons {
  position: relative;
  width: 100%;
  height: 50px;
}
.cancel-button {
  position: absolute;
  right: 0;
}
.confirm-button {
  position: absolute;
  left: 0;
}
</style>
